<template>
  <div>
    <banner></banner>

    <div class="wrapper">
      <figure>
        <div class="video">
          <iframe src="https://www.youtube.com/embed/YGjpZp_FM1E?rel=0" width="640" height="390" frameborder="0" allowfullscreen></iframe>
        </div>
        <figcaption>とり野菜みそCM映像</figcaption>
      </figure>
      <figure>
        <div class="video">
          <iframe src="https://www.youtube.com/embed/bWvzF5LcMaU?rel=0" width="640" height="390" frameborder="0" allowfullscreen></iframe>
        </div>
        <figcaption>CMメイキング映像</figcaption>
      </figure>

      <a href="http://www.toriyasaimiso.jp/" class="btnBrandtop" target="_blank">
        <img src="../assets/images/btn_footer.svg" alt="とり野菜みそオフィシャルサイトへ">
      </a>
    </div>
  </div>
</template>

<script>
  import Banner from './Banner'

  export default {
    name: 'Video',
    components: {
      Banner
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/common";

  .bnr {
    max-width: 730px;
    margin: 20px 3vw;

    @include media( sm ) {
      margin: 30px auto;
    }
  }

  .wrapper {
    max-width: calc(550px + 6vw);
    margin: 0 auto;
    padding: 0 3vw;
  }

  figure {
    .video {
      position: relative;
      padding-bottom: 56.25%;
      width: 100%;
      height: 0px;
    }

    &:not(:first-child) {
      margin-top: 35px;
    }

    @include media( sm ) {
      &:not(:first-child) {
        margin-top: 50px;
      }
    }

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    figcaption {
      margin-top: .7em;
      font: {
        size: 2.3rem;
        weight: 600;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Video.vue?e1393a96